import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

function FindButton({
  fromColorBg,
  toColorBg,
  fromColorText,
  toColorText,
  platform,
}) {
  const navigate = useNavigate();

  const getPlatformRoute = () => {
    switch (platform) {
      case 'shopee':
        return '/post/videolist';
      case 'lazada':
        return '/lazada';
      case 'tiktok':
        return '/tiktok';
      default:
        return '#';
    }
  };

  const getFindRoute = () => {
    switch (platform) {
      case 'shopee':
        return '/shopee/find';
      case 'lazada':
        return '/lazada/find';
      case 'tiktok':
        return '/tiktok/find';
      default:
        return 'find';
    }
  };

  const handleFindClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(getFindRoute());
  };

  return (
    <div className="p-2 bg-surface">
      <div
        className={`p-3 pl-0 rounded-lg w-full h-14
                     flex justify-between bg-gradient-to-r ${
                       fromColorBg || 'from-orange-400'
                     } ${toColorBg || 'to-amber-400'}`}
      >
        {platform === 'tiktok' && (
          <div className="h-full flex justify-center items-center font-bold gap-2">
            <img
              src="img/brand-logo/logo-tiktok-shop-200.png"
              alt="titkokshop"
              className="object-cover h-12"
            />
            <span>TÌM ĐƠN TIKTOK</span>
          </div>
        )}
        {platform === 'shopee' && (
          <div className="h-full flex justify-center items-center font-bold gap-2">
            <img
              src="img/ui/shopeevideo.png"
              alt="shopee"
              className="object-cover h-14 aspect-square"
            />
            <span className="text-sm">TÌM ĐƠN THẤT LẠC</span>
          </div>
        )}
        {platform === 'lazada' && (
          <div className="h-full flex justify-center items-center font-bold gap-2">
            <img
              src="img/brand-logo/logo-lazada-200.png"
              alt="lazada"
              className="object-cover h-12"
            />
            <span className="text-sm">TÌM ĐƠN LAZADA</span>
          </div>
        )}
        <button
          onClick={handleFindClick}
          className={`bg-gradient-to-r ${fromColorText || 'from-amber-800'} ${
            toColorText || 'to-amber-950'
          } px-4 py-2 rounded-xl text-white font-semibold hover:opacity-90 transition-opacity cursor-pointer leading-none`}
        >
          TÌM ĐƠN
        </button>
      </div>
    </div>
  );
}

export default FindButton;
